import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from '../../shared/constants.service';
import { environment } from '../../../environments/environment';

const KEY = 'auth';

@Injectable({ providedIn: 'root' })
export class AuthService {

  private authorization_endpoint = AppConstants.authUrl + '/oauth/authorize';
  private logout_endpoint = AppConstants.authUrl + '/users/sign_out';
  private redirect_uri = window.location.origin + '/auth/callback';

  private queryParams = {
    client_id: environment.oAuthClientId,
    response_type: 'token',
    redirect_uri: this.redirect_uri
  };

  constructor() {
  }

  signIn() {
    const params = new URLSearchParams(this.queryParams);
    window.location.href = `${this.authorization_endpoint}?${params.toString()}`;
  }

  signOut() {
    window.localStorage.removeItem(KEY);
    window.localStorage.removeItem('entities');
    window.localStorage.removeItem('permissions');
    window.location.href = this.logout_endpoint;
  }

  silentRefreshToken() {
    return new Observable((observer) => {
      const params = new URLSearchParams(this.queryParams);
      const sessionIframe = window.document.createElement('iframe');

      sessionIframe.style.display = 'none';

      window.document.body.appendChild(sessionIframe);

      sessionIframe.src = `${this.authorization_endpoint}?${params.toString()}`;
      sessionIframe.onload = () => { observer.next(this.getAccessToken()); };
      sessionIframe.onerror = () => { observer.error('Refresh error'); };
    });
  }

  getAccessToken() {
    const payload = this.getTokenPayload();

    if (!!payload) {
      return payload.access_token;
    }

    return '';
  }

  saveTokenData(data: any) {
    let auth = Object.assign({ created_at: Date.now() }, data);
    auth = JSON.stringify(auth);
    window.localStorage.setItem(KEY, auth);
  }

  private getTokenPayload() {
    const payload = window.localStorage.getItem(KEY);
    if (!!payload) {
      return JSON.parse(payload);
    }

    return null;
  }
}
